export const words = {
  place: "Locație",
  yes: "Da",
  no: "Nu",
  new: "Nou",
  agb: 'AGB',
  agb_full: "Termeni și condiții generale",
  datenschutzerklaerung: "Politica de confidențialitate",
  status: "Stare",
  company_name: "Numele companiei",
  next_button: "Mai departe",
  device_name: "Numele dispozitivului",
  to_connect: "Conectați-vă",
  pin: 'PIN',
  time: "Timp",
  first_name: "Prenume",
  last_name: "Numele de familie",
  code: "Cod",
  help: "Ajutor",
  total_time: "Timp total",
  latitude: "Latitudine",
  longitude: "Longitudine",
  accuracy: "Precizie",
  timestamp: "Timestamp",
  device_id: "ID-ul dispozitivului",
  active: "activ",
  o_clock: "Ceas",
  loading: "Magazin",
  annotation: "Notă",
  since: "de la",
  camera: "Camera",
  map: "Hartă",
  gallery: 'Galerie',
  work: "Muncă",
  employees: "Angajați",
  login: "Înregistrare",
  login_action: "Autentificare",
  calendar_week_abbreviation: 'KW',
  calendar: "Calendar",
  to_call: "Sunați la",
  email: "E-mail",
  attachment: "Anexa",
  operational_planning: "Planul operațional",
  to_scan: "Scanare",
  download: "Descărcați",
  export: "Export",
  to_document: "Document",
  checklist: "Lista de verificare",
  checklists: "Liste de verificare",
  password: "Parola",
  confirmation: "Confirmare",
  confirm: "Confirmați",
  confirmation_email: "E-mail de confirmare",
  unknown: "Necunoscut",
  unknown_place: "Locație necunoscută",
  unknown_plan: "Program de schimb fără nume",
  project_no: "Proiectul nr.",
  project_file: "Fișa proiectului",
  contact_person: "Contactați",
  overtime: "Ore suplimentare",
  timesheet: "Orar",
  minustime: "Minus ore",
  back: "Înapoi",
  undo: "Desfaceți",
  clockout: "Ștampilați",
  clocked_out: "ștampilată",
  clockin: "Ștampila în",
  clocked_in: "ștampilată",
  dismiss: "Anulează",
  discard: "Respinge",
  finish: "Gata",
  or: "sau",
  copy: "Copie",
  qr_code: "Cod QR",
  documentation: "Înregistrarea timpului și documentația",
  attendance: "Terminal pentru tablete",
  tiercontent: "Domeniul de aplicare al pachetului",
  start_now: "Începeți acum",
  skip: "skip",
  logout_during_core_time: "Ștampilat în timpul orei de bază",
  absent_during_core_time: "Absent în timpul core time",
  distance: "Distanța",
  km_reading: "Kilometraj",
  the_start: 'Start',
  the_end: "Sfârșitul",
  license_plate: "Placă de înmatriculare",
  details: "detalii",
  hide: "ascunde",
  cost: "Costuri",
  file: "Fișier",
  address_book: "Carnet de adrese",
  template_plural: "Șabloane",
  signature: "Semnătură",
  main_project: "Proiect principal",
  main_projects: "Proiecte principale",
  sub_projects: "Subproiecte",
  scan_to_login_header: "Înregistrarea codului QR",
  description: "Descriere",
  project_location: "Locația proiectului",
  phone_number: "Număr de telefon",
  project_info: "Informații despre proiect",
  number_short: "Nu.",
  sketch: "Schiță",
  video: 'Video',
  delete: "Ștergeți",
  send: "Trimiteți",
  sending: "Expedia...",
  save: "Salvați",
  granted: "aprobat",
  pending: "a solicitat",
  denied: "Respins",
  customer: "Client",
  mobile_number: "Număr de telefon",
  ok: 'Ok',
  day: "Ziua",
  tomorrow: "Dimineață",
  days: "Zile | Zi | Zile",
  holidays: "Sărbători",
  vacation_days: "Sărbători",
  vacation_hours: "Program de vacanță",
  request: "Cerere",
  accept: "Acceptă",
  withdraw: "Retrage",
  hour_account: "Cont orar",
  period: "Perioada",
  to: "la",
  date: "Programare",
  number: "Număr",
  message: "Mesaj",
  change: "schimbare",
  changed: "Modificat",
  changed_fields: "Schimbarea domeniului",
  type: "Artă",
  hour: "Ora",
  hours: "Ore",
  hours_abbreviation: 'Std.',
  hours_with_amount: "{amount} Ore",
  end: "sfârșitul",
  end_date: "Termen limită",
  start_date: "Data de începere",
  absence: "Absență",
  month: "luna",
  week: "Săptămână",
  transcript: "Transcriere",
  time_left: "Rămase",
  transcript_tasks: "Sarcini",
  add_task: "Nou",
  /** Differentiation in some languages (e.g. English) */
  from: "de la",
  of: "de la",
  of_hours: "de la {hours} ore",
  of_hours_abbreviation: "{hours} de la ore.",
  /**************/

  used: "folosit",
  update: "Actualizare",
  today: "astăzi",
  correction: "Corecție",
  work_time: "Timp de lucru",
  break: "Pauză",
  loading_time: "Timp de încărcare",
  driving_time: "Timp de călătorie",
  business_trip: "Turneu de serviciu",
  project: "Proiect",
  special_one: "Special1",
  special_two: "Special2",
  clock: "Ceas",
  search: "Căutare",
  operation: "Activitate",
  day_protocol: "Protocol zilnic",
  continue: "mai mult",
  total_duration: "Timp total",
  duration: "Durata",
  hello: "Bună ziua",
  close: "închideți",
  comment: "Comentariu",
  small: "mic",
  medium: "mediu",
  large: "mare",
  sharpie: "Pin",
  line: "Linia",
  arrow: "Săgeată",
  rectangle: "Dreptunghi",
  ellipse: "Elipsă",
  text: 'Text',
  language_settings: "Setări de limbă",
  clock_reminder: "Reamintire pentru ștampilă",
  individually: "Individ",
  from_o_clock: "de la",
  to_o_clock: "la",
  eraser: "Eraser",
  edit: "Editați",
  legal_notes: "Legal",
  notes: "Note",
  note: "Notă",
  imprint: "Imprimare",
  open_source_licenses: "Termeni de licență Open Source",
  author: 'Autor',
  license_type: "Tipul de licență",
  version: "Versiunea",
  substitute: "Reprezentare",
  not_rated: "Neevaluat",
  weekly_working_hours: "Ore de lucru săptămânale",
  show_less: "Arată mai puțin",
  office_center: "Centru de birouri",
  admin_view: "Managementul NFC",
  register: "Înregistrează-te",
  shifts: {
    shift_attachments: "Atașamente (strat)",
    shift_plan_attachments: "Atașamente (plan de schimb)",
    shift_plan: "Program de schimburi",
    shift: "Strat"
  },
  absences: {
    sick: "Boală (continuarea plății salariilor)",
    vacation: "Vacanță",
    workshop: "Seminar/Curs",
    special_vacation: "Concediu special",
    school: "Școala",
    working_time_account: "Contul de timp de lucru",
    holiday: "Vacanță",
    other: "Altele",
    driving_time: "Timp de călătorie",
    parental_leave: "Concediu parental",
    excused_absent: "Absent scuzat (plătit)",
    not_excused_absent: "Absența fără motiv",
    sick_industrial_accident: "Boală Accident de muncă (LFZ)",
    short_time_work: "Munca cu program redus (Kug)",
    maternity_pay: "Indemnizația de protecție a maternității/interdicția de angajare",
    sick_child: "Îngrijirea unui copil bolnav cu plată (zilnică) de boală",
    sick_child_no_payment: "Îngrijirea unui copil bolnav fără indemnizație de boală (zilnică)",
    vacation_no_payment: "Concediu fără plată",
    sick_before_short_time_work: "Indemnizație de boală/bolnăvire înainte de Kug",
    weather_related_failure: "Eșec din cauza condițiilor meteorologice",
    sick_short_time_work: "Boală în timpul Kug",
    sick_no_payment: "Boală (fără continuarea plății salariului)",
    company_vacation: "Sărbătorile companiei",
    meals_14_euro: "Alocație mică de catering",
    meals_28_euro: "Alocație mare de catering"
  },
  image_editor: {
    font_size: "Mărimea fontului",
    stroke_width: "Lățimea liniei",
    stroke_color: "Culoarea liniei",
    text_color: "Culoarea fontului",
    rotate_left: "Întoarceți la stânga",
    rotate_right: "Întoarceți la dreapta",
    flip_horizontal: "Oglindă pe orizontală",
    flip_vertical: "Oglindă pe verticală"
  },
  travel_log: {
    method_of_transportation: "Mijloace de transport",
    company_car: "Mașină de serviciu",
    private_car: "Mașină privată",
    rental_car: "Mașină de închiriat",
    taxi: 'Taxi',
    public_transportation: "Transport public",
    airplane: "Avion",
    train: "Căi ferate (transport public pe distanțe lungi)",
    other: "Altele",
    km_reading_start: "Mileage start",
    km_reading_end: "Sfârșitul kilometrajului",
    net_expenses: "Cheltuieli de deplasare (net)",
    tax: "Taxa pe valoarea adăugată"
  },
  read_in: "Citește în",
  currency: "Valută",
  reason: "Motivul",
  label: "Etichetă",
  monday: "Luni",
  tuesday: "Marți",
  wednesday: "Miercuri",
  thursday: "Joi",
  friday: "Vineri",
  saturday: "Sâmbătă",
  sunday: "Duminică",
  break_alarm: "Sparge ceasul deșteptător",
  clockin_reminder: "Memento la pontaj",
  clockout_reminder: "Reamintire de dezabonare"
};